module.exports = __webpack_public_path__ + "src/assets/icon_ns_bulk.png";